import {IApp} from "@/interfaces/app.interface";

export namespace ISimilarNumbers {
  export enum Action {
    SimilarNumbers = 'SimilarNumbers',
  }

  export enum Command {
    Get = 'get',
    Set = 'set',
  }

  export interface IEntity {
    carId: number;
    carNumber: string;
    carNumberNoRegion: string;
    corpName: string;
    enabled: boolean;
    corpId: number;
    carNumberGreenFlag?: boolean;

    // FE props
    status?: string;
    carNumberHtml?: string;
  }

  export enum Event {
    ReloadSimilarNumbersTable = 'reloadSimilarNumbersTable',
  }

  export const TableSimilarNumbersColumns = [
    { prop: 'carNumberHtml', label: 'Номер', },
    { prop: 'corpName',  label: 'Корпорация', },
    { prop: 'status',    label: 'Статус', },
    {
      prop: 'actions',
      label: 'Действия',
      propType: IApp.SortingPropType.CustomComponent,
      customComponentName: 'SimilarActionsCell',
    },
  ];
}